import React from 'react';
import { TreeviewDropdown } from '../../../CommonComponent';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { IProps } from './billinginfointerface';
import Loader from '../../../Loader';
import { Error } from "@progress/kendo-react-labels";
import { ICartContextType } from '../../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../../ShoppingCart/shoppingcart';

const BillingInfo = (props: IProps) => {
    const { t } = useTranslation();
    const { paymentDetails, stepperDetails, refs } = props;
    const { isShipping, isPickupAvailablePlusShipping } = stepperDetails?.fulfillment ?? {};
    const isShowPartTwo = isShipping || isPickupAvailablePlusShipping;
    const { isStepTwoLoading }: ICartContextType = useCartContext();

    return (
        <div>
            {(isStepTwoLoading || props?.savedAddressList?.loading || props?.stateList?.loading || props?.countryList?.loading) && <Loader />}
            <div className="row mb-2">
                <div className="col-12">
                    <span className="billingaddress_title">{t(RESOURCE.MyK_Label_SC_Billing_Address)}</span>
                </div>
            </div>
            {isShowPartTwo && <div className="row mb-2">
                <div className="col-12">
                    <span><input disabled={props?.savedAddressList?.loading} type="checkbox" checked={paymentDetails?.sameAsShipping ?? false} className="checkbox mr-2 billingcheckbox" onChange={(e: any) => props.onHandleChange(e?.target?.checked)} /></span><span className="billingaddress_label">{t(RESOURCE.MyK_Label_SC_Same_As_Shipping_Address)}</span>
                </div>
            </div>}
            <div className="row mb-2">
                <div className="col-6 mb-1">
                    <label>{t(RESOURCE.MyK_Label_ShoppingCart_Saved_Address)}<span className="mandatory">*</span></label>
                </div>
                <div className="col-12 col-md-12 col-lg-8 col-xl-8" ref={refs.savedAddress}>
                    <TreeviewDropdown
                        dropdownClassName={'dropdownListContainer noNested'}
                        showSearch={true}
                        treeNodeFilterProp={"title"}
                        treeData={props?.savedAddressOptions ?? []}
                        value={props?.savedAddressList?.loading ? "" : (paymentDetails?.addressId ?? 0)}
                        onChange={(e: any) => props?.onBillingInfoChange(e, 'savedAddress')}
                    />
                    {(paymentDetails?.error?.savedAddress) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Saved_Address_Req))}</Error>}
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-md-6 col-lg-4 col-xl-4 col-6" ref={refs.firstName}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_FirstName)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-12 pl-0 pr-0">
                        <input
                            value={paymentDetails?.firstName ?? ''}
                            onChange={(e: any) => props?.onBillingInfoChange(e?.target?.value ?? '', 'firstName')}
                            type="text" className="textbox"
                        />
                        {(paymentDetails?.error?.firstName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_FirstName_Req))}</Error>}
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-4 col-6" ref={refs.lastName}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_LastName)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-12 pl-0 pr-0">
                        <input
                            value={paymentDetails?.lastName ?? ''}
                            onChange={(e: any) => props?.onBillingInfoChange(e?.target?.value ?? '', 'lastName')}
                            type="text" className="textbox"
                        />
                        {(paymentDetails?.error?.lastName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_LastName_Req))}</Error>}
                    </div>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-12 col-md-12 col-lg-8 col-xl-8" ref={refs.address1}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_StreetAddress)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-12 pl-0 pr-0">
                        <input
                            value={paymentDetails?.address1 ?? ''}
                            onChange={(e: any) => props?.onBillingInfoChange(e?.target?.value ?? '', 'address1')}
                            type="text" className="textbox"
                        />
                        {(paymentDetails?.error?.address1) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_StreetAddress_Req))}</Error>}
                    </div>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-12 col-md-12 col-lg-8 col-xl-8">
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_Address2)}</label>
                    </div>
                    <div className="col-12 pl-0 pr-0">
                        <input
                            value={paymentDetails?.address2 ?? ''}
                            onChange={(e: any) => props?.onBillingInfoChange(e?.target?.value ?? '', 'address2')}
                            type="text" className="textbox"
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-12" ref={refs.city}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_City)}<span className="mandatory">*</span></label>
                    </div>
                </div>
                <div className="col-12 col-md-12 col-lg-8 col-xl-8">
                    <input
                        value={paymentDetails?.city ?? ''}
                        onChange={(e: any) => props?.onBillingInfoChange(e?.target?.value ?? '', 'city')}
                        type="text" className="textbox" />
                    {(paymentDetails?.error?.city) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_City_Req))}</Error>}
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-md-6 col-lg-4 col-xl-4 col-6" ref={refs.countryName}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_Country)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-12 pl-0 pr-0">
                        <TreeviewDropdown
                            treeData={props?.countryList?.data ?? []}
                            value={paymentDetails?.countryName ?? ''}
                            dropdownClassName={'dropdownListContainer noNested'}
                            showSearch={true}
                            onChange={(e: any) => props?.onBillingInfoChange(e, 'countryName')}
                        />

                        {(paymentDetails?.error?.countryName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Country_Req))}</Error>}
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-4 col-6"  ref={refs.stateName}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_State_Territory)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-12 pl-0 pr-0">
                        <TreeviewDropdown
                            treeData={props?.stateList?.data ?? []}
                            value={paymentDetails?.stateName ?? ''}
                            onChange={(e: any) => props?.onBillingInfoChange(e, 'stateName')}
                            dropdownClassName={'dropdownListContainer noNested'}
                            showSearch={true}
                        />
                        {(paymentDetails?.error?.stateName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_State_Req))}</Error>}
                    </div>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-md-6 col-lg-4 col-xl-4 col-6"  ref={refs.postalCode}>
                    <div className="mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_Zip)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-xl-9 col-lg-9 col-md-12 col-12 pl-0">
                        <input
                            value={paymentDetails?.postalCode ?? ''}
                            onChange={(e: any) => props?.onBillingInfoChange(e?.target?.value ?? '', 'postalCode')}
                            type="text" className="textbox" />
                        {(paymentDetails?.error?.postalCode) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Zip_Req))}</Error>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BillingInfo